(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[15932],{

/***/ 94304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DebtReliefMean; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sharedButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84442);




function DebtReliefMean() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: `flex flex-col lg:flex-row  lg:gap-48 gap-8 lg:mt-36 mt-16   `,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-[221px] h-[253px] md:w-[430px] md:min-w-[430px] md:h-[474px] relative mx-auto lg:mx-0 lg:mt-16 lg:left-10 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: "/debtreliefgate/assets/images/meanImg.png",
                    alt: "Image",
                    layout: "fill"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-[530px] mx-auto lg:mx-0 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "font-bold lg:text-3xl text-2xl lg:leading-[45px] text-[#274DC2] ",
                        children: "What Does Debt Relief Mean?"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mt-7 lg:text-lg text-base lg:leading-8 ",
                        children: "Debt relief is like discovering a secret treasure map for individuals or businesses burdened by debt. It's about lightening the load and finding financial solace. Debt relief companies offer solutions and strategies like debt consolidation, debt settlement, or debt management plans at your disposal."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mt-4 lg:text-lg text-base lg:leading-8 ",
                        children: "Reputable debt relief companies and credit counseling agencies do the work for you, negotiating with creditors, securing lower interest rates, slashing overall debt, or devising feasible repayment plans. Prepare to take control of your finances and embark on a thrilling journey towards a debt-free future!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "sm:mt-12 mt-8 text-center sm:text-left",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sharedButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 21546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MainBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_shared_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96119);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50780);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _styles_variables_homewarrantyestimateVariables_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47496);
/* harmony import */ var _styles_variables_homewarrantyestimateVariables_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_variables_homewarrantyestimateVariables_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);
/* harmony import */ var _components_shared_textBlockOffer_TextBlockOffer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45464);









function MainBanner() {
    const { visitDetails , domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const isFormDisplayed = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .finalShowForm */ .r6)(router.query.sl, domain.showForm, domain.defaultOffers);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isFormDisplayed ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["main-banner"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_form__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                classes: {
                    formClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().form),
                    stepTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["step-title"]),
                    stepDescriptionClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["step-description"]),
                    formButtonClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["form-button"]),
                    formFieldClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["form-field"]),
                    formStepInnerClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["steps-inner"]),
                    stepClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().step),
                    fieldsClassName: {
                        radio: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["radio-field"]),
                        checkbox: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["checkbox-field"]),
                        all: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().field),
                        input: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["input-field"])
                    },
                    fieldsWrapperClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["fields-wrapper"]),
                    tcpaClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tcpa),
                    labelAsTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["label-as-step-title"]),
                    fieldNoteClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["field-note"]),
                    fieldErrorMessageClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["field-error-message"]),
                    sellingPointClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["selling-point"]),
                    formProgressbarClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["progress-background"])
                },
                colors: {
                    primaryColor: (_styles_variables_homewarrantyestimateVariables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().mainColor),
                    progressBar: "#B3B3B3"
                },
                showProgress: true,
                goToThankYouPage: false,
                sellingPoint: visitDetails?.region ? `${visitDetails?.region}'s Best Debt Relief Companies` : "",
                sellingPointsSteps: "FIRST_STEP",
                dynamicThankYouFields: [
                    "firstName"
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_textBlockOffer_TextBlockOffer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
    });
}


/***/ }),

/***/ 84442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SharedButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37821);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function SharedButton() {
    const scrollToTop = ()=>{
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: ()=>scrollToTop(),
        className: `bg-[#FFBC10]  py-4 sm:px-16 px-4 sm:text-lg font-semibold rounded-[13px] ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_1___default().animation)}`,
        children: "Get My Free Debt Relief Consultation"
    });
}


/***/ }),

/***/ 21553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UnlockAdvantages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/debtreliefgate/unlockAdvantages/style.module.scss
var style_module = __webpack_require__(69892);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/components/debtreliefgate/sharedButton/index.tsx
var sharedButton = __webpack_require__(84442);
;// CONCATENATED MODULE: ./src/components/debtreliefgate/unlockAdvantages/icons/quickAndEasy.tsx


function QuickAndEasy() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "56",
        height: "56",
        fill: "none",
        viewBox: "0 0 56 56",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "27.859",
                cy: "27.859",
                r: "27.859",
                fill: "#264DC2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M36.678 15.91h-4.193v-1.648a.445.445 0 00-.433-.433h-9.02a.445.445 0 00-.435.433v1.62h-4.192a.445.445 0 00-.434.433v23.968c0 .232.203.434.434.434h18.273a.445.445 0 00.433-.434v-23.94a.445.445 0 00-.433-.433zm-13.213-1.214h8.182v3.267h-8.182v-3.267zM36.244 39.85H18.839V16.778h3.73v1.619c0 .231.202.433.433.433h9.05a.445.445 0 00.433-.433v-1.62h3.73V39.85h.029z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M33.758 32.708H21.325a.445.445 0 00-.433.434v3.354c0 .231.202.433.433.433H33.73a.445.445 0 00.433-.433v-3.354c.03-.231-.173-.434-.404-.434zm-.434 3.354H21.759v-2.486h11.565v2.486zM33.758 26.926H21.325a.445.445 0 00-.433.434v3.353c0 .232.202.434.433.434H33.73a.445.445 0 00.433-.434V27.36c.03-.23-.173-.433-.404-.433zm-.434 3.354H21.759v-2.487h11.565v2.487zM20.892 21.577v3.354c0 .231.202.434.433.434H33.73a.445.445 0 00.433-.434v-3.354a.445.445 0 00-.433-.434H21.325a.445.445 0 00-.433.434zm.867.434h11.565v2.486H21.759v-2.486z"
            })
        ]
    });
}
/* harmony default export */ var quickAndEasy = (QuickAndEasy);

;// CONCATENATED MODULE: ./src/components/debtreliefgate/unlockAdvantages/icons/professionalsAssess.tsx


function ProfessionalsAssess() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "56",
        height: "56",
        fill: "none",
        viewBox: "0 0 56 56",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "27.859",
                cy: "27.859",
                r: "27.859",
                fill: "#264DC2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M15.918 39.63a.383.383 0 01-.371-.476l1.539-6.047c-1.287-.868-2.308-1.875-3.037-2.995-.81-1.245-1.22-2.572-1.22-3.944 0-2.663 1.553-5.154 4.372-7.017 2.771-1.83 6.448-2.837 10.353-2.837 3.905 0 7.582 1.008 10.353 2.837 2.82 1.863 4.372 4.355 4.372 7.017 0 2.663-1.553 5.155-4.372 7.017-2.771 1.83-6.448 2.837-10.353 2.837-1.984 0-3.906-.257-5.717-.767l-5.688 4.298a.385.385 0 01-.231.078zm11.636-22.55c-7.697 0-13.96 4.077-13.96 9.088 0 2.434 1.47 4.724 4.138 6.448a.382.382 0 01.162.416l-1.336 5.253 4.97-3.756a.385.385 0 01.34-.062c1.795.524 3.708.79 5.687.79 7.697 0 13.96-4.077 13.96-9.089 0-5.011-6.263-9.089-13.96-9.089z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M21.778 28.749a.384.384 0 01-.178-.044l-1.666-.876-1.665.876a.382.382 0 01-.555-.404l.318-1.854-1.348-1.314a.383.383 0 01.212-.653l1.863-.27.832-1.687a.383.383 0 01.687 0l.833 1.687 1.862.27a.383.383 0 01.212.653l-1.348 1.314.318 1.854a.383.383 0 01-.377.448zm-1.844-1.735c.062 0 .123.015.178.044l1.158.608-.221-1.288a.384.384 0 01.11-.34l.936-.912-1.294-.188a.383.383 0 01-.288-.21l-.579-1.172-.578 1.173a.383.383 0 01-.288.21l-1.294.187.936.913c.09.088.131.215.11.339l-.221 1.288 1.157-.608a.382.382 0 01.178-.044zM29.495 28.749a.384.384 0 01-.178-.044l-1.665-.876-1.666.876a.382.382 0 01-.555-.404l.318-1.854-1.347-1.314a.382.382 0 01.212-.653l1.862-.27.833-1.687a.383.383 0 01.686 0l.833 1.687 1.861.27a.383.383 0 01.212.653l-1.347 1.314.318 1.854a.382.382 0 01-.377.448zm-1.843-1.735c.061 0 .122.015.178.044l1.157.608-.221-1.288a.384.384 0 01.11-.34l.936-.912-1.293-.188a.382.382 0 01-.288-.21l-.579-1.172-.58 1.173a.38.38 0 01-.287.21l-1.294.188.937.912c.09.088.13.215.11.34l-.222 1.288 1.157-.609a.38.38 0 01.18-.044zM37.213 28.749a.386.386 0 01-.178-.044l-1.666-.876-1.665.876a.382.382 0 01-.555-.404l.318-1.854-1.347-1.314a.384.384 0 01.211-.653l1.862-.27.833-1.687a.383.383 0 01.687 0l.833 1.687 1.862.27a.383.383 0 01.211.653l-1.348 1.314.319 1.854a.384.384 0 01-.377.448zm-1.844-1.735a.38.38 0 01.178.044l1.157.608-.22-1.288a.383.383 0 01.11-.34l.935-.912-1.293-.188a.38.38 0 01-.288-.21l-.58-1.172-.578 1.173a.38.38 0 01-.288.21l-1.294.187.937.913c.09.088.13.215.11.339l-.221 1.288 1.157-.608a.384.384 0 01.178-.044z"
            })
        ]
    });
}
/* harmony default export */ var professionalsAssess = (ProfessionalsAssess);

;// CONCATENATED MODULE: ./src/components/debtreliefgate/unlockAdvantages/icons/readAndSign.tsx


function ReadAndSign() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "56",
        height: "56",
        fill: "none",
        viewBox: "0 0 56 56",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "27.859",
                cy: "27.859",
                r: "27.859",
                fill: "#264DC2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M15.833 36.794l6.35-4.114h7.68c.269 0 .528.107.718.296.191.189.298.446.298.713v1.073h-5.812a.541.541 0 00-.381.157.532.532 0 00.38.912h6.278c.015 0 .029 0 .044-.002a.54.54 0 00.382-.127l6.614-5.656a1.019 1.019 0 011.599.369.99.99 0 01.08.405.99.99 0 01-.336.738l-7.543 6.744a1.563 1.563 0 01-1.044.397h-7.795a.543.543 0 00-.252.063l-4.235 2.231a.535.535 0 00-.223.723.536.536 0 00.476.284.541.541 0 00.253-.063l4.116-2.169h7.66c.653 0 1.282-.239 1.766-.672l7.543-6.744a2.085 2.085 0 00.692-1.52 2.07 2.07 0 00-.659-1.536 2.098 2.098 0 00-2.802-.06l-5.723 4.893v-.44a2.07 2.07 0 00-.614-1.469 2.106 2.106 0 00-1.48-.609h-7.84a.542.542 0 00-.295.087l-6.484 4.2a.534.534 0 00.184.971c.14.03.286.002.405-.075zM28.918 14.069c2.438 0 4.422 1.967 4.422 4.386a4.34 4.34 0 01-.756 2.456c-.222.35-1.49 2.409-1.764 3.936h-3.804c-.275-1.528-1.544-3.588-1.764-3.937a4.34 4.34 0 01-.756-2.456c0-2.418 1.984-4.385 4.422-4.385zm-4.593 7.387c.463.729 1.666 2.855 1.666 3.925a.53.53 0 00.333.494c.065.027.135.04.206.04h4.777a.541.541 0 00.539-.534c0-1.068 1.202-3.195 1.666-3.925a5.399 5.399 0 00.906-3c0-3.009-2.467-5.456-5.5-5.456-3.032 0-5.499 2.447-5.499 5.455a5.4 5.4 0 00.907 3zM31.824 27.217a.54.54 0 00-.539-.535h-4.648a.541.541 0 00-.381.157.532.532 0 00.38.913h4.649a.542.542 0 00.497-.33.53.53 0 00.041-.205h.001zM27.715 28.431a.541.541 0 00-.539.535.53.53 0 00.333.493c.065.027.135.041.206.041h2.492a.541.541 0 00.498-.33.53.53 0 00-.291-.698.544.544 0 00-.207-.041h-2.492z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M27.908 21.253a.539.539 0 00.762 0l3.288-3.261a.532.532 0 00-.381-.913.541.541 0 00-.381.157l-2.907 2.884-1.202-1.193a.541.541 0 00-.92.378c0 .142.057.278.158.378l1.582 1.57z"
            })
        ]
    });
}
/* harmony default export */ var readAndSign = (ReadAndSign);

;// CONCATENATED MODULE: ./src/components/debtreliefgate/unlockAdvantages/icons/personalizedDebtRelief.tsx


function PersonalizedDebtRelief() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "56",
        height: "56",
        fill: "none",
        viewBox: "0 0 56 56",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "27.859",
                cy: "27.859",
                r: "27.859",
                fill: "#264DC2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M18.392 23.754v8.557c0 .865.344 1.696.954 2.308.61.612 1.438.956 2.3.957h3.637L22.49 38.38a.653.653 0 10.92.924l3.906-3.919a.655.655 0 000-.924l-3.906-3.918a.65.65 0 00-1.103.464.654.654 0 00.183.46l2.794 2.803h-3.636a1.952 1.952 0 01-1.38-.574 1.965 1.965 0 01-.573-1.385v-8.557a4.553 4.553 0 002.898-1.658 4.582 4.582 0 00-.444-6.214 4.549 4.549 0 00-6.21 0 4.578 4.578 0 00-.445 6.214 4.554 4.554 0 002.899 1.658zm.65-7.772a3.248 3.248 0 013.008 2.016 3.275 3.275 0 01-.705 3.56 3.252 3.252 0 01-3.548.707 3.257 3.257 0 01-1.46-1.203 3.274 3.274 0 01.405-4.122 3.254 3.254 0 012.3-.958zm18.88 14.435v-8.556a3.275 3.275 0 00-.954-2.308 3.254 3.254 0 00-2.3-.958H31.03l2.795-2.804a.654.654 0 00-.463-1.107.65.65 0 00-.458.184l-3.906 3.918a.652.652 0 000 .924l3.906 3.919a.65.65 0 001.103-.464.654.654 0 00-.182-.46l-2.795-2.804h3.636c.518 0 1.015.207 1.38.575.367.367.573.865.573 1.385v8.556a4.554 4.554 0 00-2.898 1.658 4.582 4.582 0 00.445 6.214 4.549 4.549 0 006.21 0 4.578 4.578 0 00.444-6.214 4.554 4.554 0 00-2.899-1.658zm-.65 7.772a3.248 3.248 0 01-3.008-2.016 3.275 3.275 0 01.706-3.559 3.252 3.252 0 013.547-.708 3.273 3.273 0 011.055 5.325 3.254 3.254 0 01-2.3.958z"
            })
        ]
    });
}
/* harmony default export */ var personalizedDebtRelief = (PersonalizedDebtRelief);

;// CONCATENATED MODULE: ./src/components/debtreliefgate/unlockAdvantages/icons/achieveFinancialFreedom.tsx


function AchieveFinancialFreedom() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "56",
        height: "56",
        fill: "none",
        viewBox: "0 0 56 56",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "27.859",
                cy: "27.859",
                r: "27.859",
                fill: "#264DC2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#fff",
                clipPath: "url(#clip0_2_153)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M27.723 35.59a.46.46 0 00.449-.448v-1.196a.46.46 0 00-.449-.449.46.46 0 00-.448.449v1.196c0 .24.179.449.448.449zM29.308 35.86c.06.03.09.03.15.03a.45.45 0 00.419-.299l.418-1.107c.09-.239-.03-.508-.269-.568-.24-.09-.508.03-.568.27l-.419 1.106c-.09.24.03.478.27.568zM26.018 34.155c-.09-.24-.359-.359-.568-.269-.24.09-.359.359-.27.568l.42 1.107c.06.18.239.299.418.299.06 0 .09 0 .15-.03.24-.09.359-.359.269-.568l-.419-1.107zM27.723 39.3a.46.46 0 00-.448.448v1.197c0 .239.209.448.448.448a.46.46 0 00.449-.448v-1.197a.44.44 0 00-.449-.448zM26.138 39c-.24-.089-.509.03-.568.27l-.42 1.107c-.089.239.03.508.27.568.06.03.09.03.15.03a.45.45 0 00.418-.3l.42-1.106c.089-.21-.03-.479-.27-.568zM29.877 39.3c-.09-.24-.36-.36-.569-.27-.239.09-.359.36-.269.569l.419 1.106c.06.18.24.3.419.3.06 0 .09 0 .15-.03.238-.09.358-.36.268-.569l-.418-1.106z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M26.347 16.599v-1.556c0-.807-.658-1.465-1.465-1.465-.33 0-.598.09-.838.269-.269-.329-.688-.568-1.136-.568-.3 0-.598.09-.838.269a1.458 1.458 0 00-1.166-.598c-.479 0-.897.239-1.166.598-.24-.18-.509-.27-.838-.27-.807 0-1.465.659-1.465 1.466v1.406c-.539.3-.898.837-.987 1.495l-.27 1.945c-.15 1.046.18 2.093.898 2.9l1.734 1.975v1.106h-.508a.46.46 0 00-.449.449v2.722c0 .239.21.448.449.448h1.645v.898a1.445 1.445 0 00-1.107 1.405v.599c0 .807.658 1.465 1.466 1.465h.18l.747 1.466c-.21.179-.359.388-.419.628-.12.359-.09.777.09 1.106l.27.539c.268.508.777.807 1.315.807.21 0 .449-.06.658-.15l.18-.09c.12-.059.239-.149.328-.238l1.974.358h.09c.21 0 .419-.149.449-.358.06-.24-.12-.479-.359-.539l-1.735-.329c.03-.299 0-.598-.15-.867l-.268-.538c-.3-.599-.987-.898-1.616-.778l-.688-1.346c.36-.27.599-.688.599-1.166v-.599c0-.688-.479-1.256-1.107-1.405v-.898h4.516a.46.46 0 00.449-.448V25.99a.46.46 0 00-.449-.449h-.508v-1.106l.21-.12c.986-.628 1.584-1.675 1.584-2.811 0-1.197-.06-2.902-.388-4.457a1.2 1.2 0 00.09-.448zM22.37 35.47c.21 0 .39.12.479.3l.27.538c.059.12.089.269.03.418-.06.15-.15.24-.27.33l-.18.09a.513.513 0 01-.717-.24l-.27-.538a.506.506 0 01-.03-.42c.06-.149.15-.238.27-.328l.18-.09c.089-.06.149-.06.238-.06zm-1.286-3.978v.599c0 .299-.239.538-.538.538h-.21c-.299 0-.538-.24-.538-.538v-.599c0-.299.24-.538.539-.538h.209c.27-.03.538.24.538.538zm3.29-16.45c0-.299.24-.538.539-.538.299 0 .538.24.538.538V16.6c0 .299-.24.538-.538.538-.3 0-.539-.24-.539-.538v-1.556zm-2.004-.269c0-.299.24-.538.539-.538.299 0 .538.24.538.538v2.124c0 .299-.24.538-.538.538-.3 0-.539-.24-.539-.538v-2.124zm-2.003-.329c0-.299.239-.538.538-.538.299 0 .538.24.538.538v1.645c-.18-.09-.359-.12-.568-.15h-.508v-1.495zm-1.974.33c0-.3.239-.54.538-.54.299 0 .538.24.538.54v1.136l-.927-.03h-.15v-1.107zm6.55 11.694v1.794h-4.068v-.478a.46.46 0 00-.449-.45.46.46 0 00-.448.45v.508H18.81v-1.794h6.132v-.03zm.837-4.995c0 .837-.449 1.615-1.166 2.064l-.42.269c-.119.09-.209.239-.209.389v1.375h-4.217v-1.286c0-.12-.03-.21-.12-.299l-1.854-2.094c-.508-.598-.777-1.375-.658-2.153l.27-1.944c.06-.568.568-.987 1.136-.957l2.333.06c.3 0 .509.239.509.538 0 .15-.06.27-.15.389-.12.03-.27.09-.389.09l-1.615-.06c-.24 0-.449.15-.479.389l-.15 1.017c-.029.239.12.478.39.508.239.03.478-.12.508-.389l.09-.508c1.615.747 1.495 2.303 1.465 2.392-.03.24.15.479.42.509h.059c.24 0 .419-.18.449-.419.06-.628-.12-1.705-.928-2.542.3-.03.599-.18.808-.389.09-.09.18-.21.24-.329.239.15.508.24.807.24.448 0 .867-.21 1.136-.569.24.18.539.3.838.3.21 0 .418-.06.628-.15.24 1.256.27 2.602.27 3.559zM38.34 22.49a3.771 3.771 0 00.898-2.9l-.27-1.944a2.086 2.086 0 00-.986-1.496v-1.376c0-.807-.658-1.465-1.466-1.465-.299 0-.598.09-.837.269a1.458 1.458 0 00-1.166-.598c-.48 0-.898.24-1.167.598-.24-.18-.508-.27-.837-.27-.449 0-.868.21-1.137.57a1.4 1.4 0 00-.837-.27c-.808 0-1.466.658-1.466 1.465v1.556c0 .15.03.299.09.448-.33 1.526-.389 3.23-.389 4.427 0 1.166.598 2.213 1.585 2.811l.21.12v1.107h-.509a.46.46 0 00-.449.448v2.722c0 .24.21.449.449.449h4.516v.897a1.445 1.445 0 00-1.106 1.406v.598c0 .478.239.897.598 1.166l-.688 1.346a1.428 1.428 0 00-1.615.778l-.27.538c-.119.27-.149.568-.119.867l-1.675.3c-.24.06-.419.269-.359.538.03.21.24.359.449.359h.09l1.974-.359c.09.09.209.18.329.24l.179.089c.21.09.419.15.658.15.538 0 1.047-.3 1.316-.808l.27-.538a1.47 1.47 0 00-.36-1.765l.748-1.466h.18c.807 0 1.465-.658 1.465-1.465v-.598c0-.688-.479-1.257-1.107-1.406v-.897h1.645a.46.46 0 00.449-.449V25.96a.46.46 0 00-.449-.448h-.508v-1.107l1.675-1.914zM33.736 36.34l-.27.538c-.149.27-.478.389-.717.24l-.18-.09a.513.513 0 01-.239-.718l.27-.538c.089-.18.298-.3.478-.3.09 0 .18.03.24.06l.179.09c.269.12.388.449.239.718zm1.914-4.845v.598c0 .299-.24.538-.538.538h-.21c-.299 0-.538-.24-.538-.538v-.598c0-.3.24-.539.538-.539h.21c.299-.03.538.24.538.539zm.329-16.72c0-.299.24-.538.538-.538.3 0 .539.24.539.538v1.137h-.15l-.927.03v-1.167zm-2.004-.329c0-.299.24-.538.539-.538.299 0 .538.24.538.538v1.496h-.509c-.209 0-.388.06-.568.15v-1.646zm-1.974.33c0-.3.24-.539.538-.539.3 0 .539.24.539.538v2.124c0 .299-.24.538-.538.538-.3 0-.539-.239-.539-.538v-2.124zm-2.004.269c0-.3.24-.539.539-.539.299 0 .538.24.538.539v1.555c0 .299-.24.538-.538.538-.3 0-.539-.24-.539-.538v-1.555zm6.64 11.425v1.794H35.47v-.478a.46.46 0 00-.45-.449.46.46 0 00-.448.449v.508h-4.067V26.5h6.131v-.03zm-.837-2.483c-.06.09-.12.18-.12.3v1.285h-4.217v-1.375c0-.15-.09-.3-.21-.39l-.418-.268c-.718-.449-1.137-1.227-1.167-2.064 0-.957.03-2.303.24-3.59.179.09.388.15.628.15.329 0 .598-.12.837-.299.27.33.688.569 1.137.569.299 0 .568-.09.807-.24.06.12.15.24.24.33.239.209.508.358.807.388-.808.838-.987 1.914-.927 2.543.03.239.21.418.448.418h.06c.24-.03.419-.24.419-.508 0-.09-.12-1.645 1.465-2.393l.09.509c.03.239.27.418.509.388.239-.03.418-.269.389-.508l-.12-1.017c-.03-.24-.24-.389-.479-.389l-1.615.09c-.15 0-.299-.06-.389-.15-.12-.09-.15-.239-.15-.389 0-.299.24-.538.51-.538l2.332-.06c.569 0 1.047.419 1.137.957l.269 1.945c.09.777-.15 1.585-.658 2.153l-1.854 2.153z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2_153",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H31.451V29H0z",
                        transform: "translate(12 13)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var achieveFinancialFreedom = (AchieveFinancialFreedom);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/debtreliefgate/unlockAdvantages/index.tsx










const UnlockAdvantagesList = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(quickAndEasy, {}),
        description: "Just fill out our quick and easy form"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(professionalsAssess, {}),
        description: "Let our professionals assess your debts and find the best plans and programs for you"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(readAndSign, {}),
        description: "Be sure to carefully read and sign agreements so you fully grasp the terms before committing to a debt relief plan"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(personalizedDebtRelief, {}),
        description: "Put your personalized debt relief strategy into action"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(achieveFinancialFreedom, {}),
        description: "Achieve financial freedom and secure your future!"
    }, 
];
function UnlockAdvantages() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (style_module_default()).mainContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col lg:flex-row lg:gap-20 gap-12 lg:pt-24 pt-12 lg:pb-48 pb-24",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-[645px] mx-auto lg:mx-0 ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-bold lg:text-3xl text-2xl lg:leading-10 text-[#264DC2] text-center sm:text-left",
                            children: "Unlock the Advantages of Debt Settlement"
                        }),
                        UnlockAdvantagesList.map((advantage, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-10 sm:mt-6 first-of-type:mt-10 flex flex-col sm:flex-row lg:gap-7 gap-5 items-center ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: advantage.icon
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "lg:text-xl lg:leading-8 text-center sm:text-left",
                                        children: advantage.description
                                    })
                                ]
                            }, index)),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:mt-28 mt-16 text-center sm:text-left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedButton/* default */.Z, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " w-[441px] min-w-[441px] h-[369px] relative mt-24 hidden lg:block ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/debtreliefgate/assets/images/unlockImg.png",
                        alt: "Image",
                        layout: "fill"
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 43502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WhySeekDebtRelief; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sharedButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84442);




function WhySeekDebtRelief() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "flex flex-col lg:flex-row lg:gap-40 gap-8 lg:mt-28 mt-24 ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-[550px] mx-auto lg:mx-0 order-2 lg:order-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "font-bold lg:text-3xl text-2xl lg:leading-[45px] text-[#274DC2] ",
                        children: "Why Should You Seek Debt Relief?"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mt-7 font-light lg:text-lg text-base lg:leading-8 ",
                        children: "Being in debt can feel overwhelming, and it might make you feel like you're stuck in a never-ending cycle. But guess what? There's good news! With a reliable and trustworthy debt relief company, you can finally find the financial freedom you've been longing for."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mt-4 font-light lg:text-lg text-base lg:leading-8 ",
                        children: "Whether you're an individual or a business, there are debt relief programs out there for you. From debt consolidation to settlement, management plans to bankruptcy, student loan forgiveness to mortgage relief, a savvy provider can expertly guide you to the path that suits you best. They'll offer the relief and freedom from debt that you truly deserve. So why not take the first step towards a debt-free life?"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "sm:mt-12 mt-8 text-center sm:text-left",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sharedButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-[221px] h-[253px] md:w-[430px] md:min-w-[430px] md:h-[474px] relative mx-auto lg:mx-0 order-1 lg:order-2 lg:mt-12 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: "/debtreliefgate/assets/images/seekImg.png",
                    alt: "Image",
                    layout: "fill"
                })
            })
        ]
    });
}


/***/ }),

/***/ 50780:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","selling-point":"styles_selling-point__6EeUP","main-banner":"styles_main-banner__EiQfs","form":"styles_form__skkTU","step":"styles_step__RWvpj","form-field":"styles_form-field__rdX26","step-title":"styles_step-title__oUnMg","steps-inner":"styles_steps-inner__gdATK","label-as-step-title":"styles_label-as-step-title__oiUDg","step-description":"styles_step-description__cbMqB","fields-wrapper":"styles_fields-wrapper__r8gXL","form-button":"styles_form-button__HlmJy","radio-field":"styles_radio-field__cE8gz","checkbox-field":"styles_checkbox-field__R0O3p","field-note":"styles_field-note__GVrGt","input-field":"styles_input-field__klKcM","field-error-message":"styles_field-error-message__Zz4VI","field":"styles_field__dFjYk","tcpa":"styles_tcpa__LUwOh","image":"styles_image__enOzI"};

/***/ }),

/***/ 37821:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animation":"style_animation__MQAlV"};

/***/ }),

/***/ 69892:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animation":"style_animation__sEzDm","mainContainer":"style_mainContainer__UEvk0"};

/***/ }),

/***/ 47496:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#244880","paragraphColor":"#232323"};

/***/ })

}]);